/* global $ */

const $map = $('.js-contact-map');

const contactMap = {
  initialize() {
    if (!$map.length) {
      return;
    }

    $map.on('click', '.js-contact-map-marker', (event) => {
      event.stopPropagation();
      const { currentTarget } = event;
      this.closeMarkers();
      this.openMarker(currentTarget);
    });

    $map.on('click', () => {
      this.closeMarkers();
    });
  },

  openMarker(markerElement: HTMLButtonElement) {
    markerElement.classList.add('is-open');
  },

  closeMarkers() {
    $map.find('.js-contact-map-marker.is-open').removeClass('is-open');
  },
};

export default contactMap;
